import { Get, PostWithAccessToken } from "../../helpers/http";



export const GetMedicalHistory = async (data) => {
    // return (await PostWithAccessToken('http://localhost:9002/api/Dashboard/historyRevised', data)).json();
    return (await PostWithAccessToken(`${process.env.REACT_APP_DOCTOR_API_URL}Dashboard/historyRevised`, data)).json();
}

export const GetProcedureCodeList = async (companyId) => {
    // return (await Get(`https://localhost:7092/api/MedicalNote/get-procedure-list?companyId=${companyId}`)).json();
    return (await Get(`${process.env.REACT_APP_LAW_API_URL}MedicalNote/get-procedure-list?companyId=${companyId}`)).json();
}